<template>
  <v-main>
    <v-container fluid class="fill-height">
      <v-row>
        <v-col>
          <v-card class="mx-auto" max-width="550px">
            <v-toolbar color="primary" dark>
              <v-toolbar-title>{{ title }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <!-- <v-btn
                rounded
                class="red--text font-weight-bold"
                color="white"
                @click="toggleComp()"
                >{{ btnTitle }}</v-btn
              > -->
            </v-toolbar>
            <QrCodeView/>
            <!-- <component
              v-on:callToggle="toggleComp"
              :switch="toggleComp"
              :is="component"
            /> -->
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import QrCodeView from "@/components/views/QrCodeView";
//import AddMedications from "@/components/forms/AddMedication";
export default {
  name: "Medications",
  components: {
    QrCodeView
  },
  events: {
    callToggle() {
      this.toggleComp();
    }
  },
  data: () => ({
    //component: QrCodeView,
    title: "Your QR Code",
    btnTitle: "Edit"
  }),
  methods: {
    /* toggleComp() {
      if (this.component === QrCodeView) {
        this.component = AddMedications;
        this.title = "Edit";
        this.btnTitle = "Back";
      } else {
        this.component = QrCodeView;
        this.title = "Your QrCode";
        this.btnTitle = "Edit";
      }
    } */
  }
}
</script>

<style>
</style>